export default __webpack_public_path__ + "6972dc2.png";